/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%] {\n  white-space: nowrap; }\n\n.box-filter[_ngcontent-%COMP%], .box-parent[_ngcontent-%COMP%] {\n  background: #FFFFFF;\n  padding: 1.5em 2em 20px 2em !important;\n  border-radius: 10px 10px 0 0;\n  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.box-parent[_ngcontent-%COMP%] {\n  border-radius: 0 0 10px 10px; }\n\n.header[_ngcontent-%COMP%] {\n  margin: unset;\n  padding: 40px 0px 20px;\n  color: #4A4A4A; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-form/document-form.component.scss.shim.ngstyle.js.pre-build-optimizer.js